const availableLanguages = ["en", "fr"];
export default availableLanguages;